// import { createSlice } from "@reduxjs/toolkit";
// import {  GetProject, GetAdminAllProject} from "./ThunkAction";
//  import { iProjectState, REDUCER_NAME } from "./Types";

// // Define initial state based on the provided structure
// const initialState: iProjectState = {
//   isLoading: false,
//   projectList: [],
//   adminProjectList:[],
//   errorMessage: null,
// };

// export const projectListSlice = createSlice({
//   name: REDUCER_NAME,
//   initialState,
//   reducers: {
//     resetLogoState: () => {
//       return initialState;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(GetProject.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(GetProject.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.projectList = payload.data.data;
//           state.isLoading = false;
//         }
//       })
//       .addCase(GetProject.rejected, (state, action) => {
//         state.errorMessage = "Failed to fetch Logo data";
//         state.isLoading = false;
//       });
//   },
// });

// export const { resetLogoState } = projectListSlice.actions;
// export default projectListSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";
import { GetProject, GetAdminAllProject } from "./ThunkAction";
import { iProjectState, REDUCER_NAME } from "./Types";

// Define initial state
const initialState: iProjectState = {
  isLoading: false,
  projectList: [],
  adminProjectList: [],
  errorMessage: null,
};

export const projectListSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetLogoState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🧩 GetProject Thunk
      .addCase(GetProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetProject.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.projectList = payload.data.data;
        }
        state.isLoading = false;
      })
      .addCase(GetProject.rejected, (state) => {
        state.errorMessage = "Failed to fetch project data";
        state.isLoading = false;
      })

      // 🧩 GetAdminAllProject Thunk
      .addCase(GetAdminAllProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAdminAllProject.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.adminProjectList = payload.data.data;
        }
        state.isLoading = false;
      })
      .addCase(GetAdminAllProject.rejected, (state) => {
        state.errorMessage = "Failed to fetch admin project data";
        state.isLoading = false;
      });
  },
});

export const { resetLogoState } = projectListSlice.actions;
export default projectListSlice.reducer;
